export const isSafari = () => {
	if (typeof navigator !== 'undefined') {
		/^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	}
	return false;
};
